/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { Dropdown, Image } from 'react-bootstrap';
import { getUserBankingDetails, updateBankingDetails } from '../../actions/profileActions';
import './PersonalDetails.css';
import { postToController } from '../../actions/apiActions';
import { hideLoadingScreen, showLoadingScreen } from '../../actions/fullscreenActions';
import { createQuoteFromPolicyCardUpdate, IveriSubmission } from '../../actions/salesActions';
import { showChangeCreditCard } from '../../actions/modalActions';
import { SA_COUNTRY_ID_NUMBER } from '../../constants/internationalization';
import { NAM_BANKS_AND_BRANCHES } from '../../constants/namibiaBanks';

class PaymentDeets extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            isInEdit: false,
            addPayment: false,
            editHolder: this.props.profile.bankingDetails.accountholder,
            editAccountNumber: "",
            currBank: this.props.profile.bankingDetails.bank,
            currBranch: this.props.profile.bankingDetails.branchName,
            currAccountType: this.props.profile.bankingDetails.bankAccountType,
            bankList: [],
            accountTypeList: [],
            branchList: [],
            debitDayList: [],
            selectedBank: {},
            selectedBranch: {},
            selectedAccountType: {},
            selectedDebitDay: {},
            bankingDetailsEmpty: true,
            branchDetailsEmpty: true,
            bankDropdownOpen: false,
            branchDropdownOpen: false,
            accountTypeDropdownOpen: false,
            debitDayDropdownOpen: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.showFieldUpdate = this.showFieldUpdate.bind(this);
        this.getLists = this.getLists.bind(this);
        this.cancelEdit = this.cancelEdit.bind(this);
        this.editInfo = this.editInfo.bind(this);
        this.saveEdit = this.saveEdit.bind(this)
        this.addNewPayment = this.addNewPayment.bind(this);
        this.getBankDetails = this.getBankDetails.bind(this);
        this.handleBankDropdownToggle = this.handleBankDropdownToggle.bind(this);
        this.handleBankSelection = this.handleBankSelection.bind(this);
        this.handleBranchDropdownToggle = this.handleBranchDropdownToggle.bind(this);
        this.handleBranchSelection = this.handleBranchSelection.bind(this);
        this.handleAccountTypeDropdownToggle = this.handleAccountTypeDropdownToggle.bind(this);
        this.handleAccountTypeSelection = this.handleAccountTypeSelection.bind(this);
        this.handleUpdateBankDetails = this.handleUpdateBankDetails.bind(this);
    }

    async componentDidMount() {
        await this.getLists();
    }
    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async handleUpdateBankDetails() {
        await this.props.dispatchShowLoadingScreen();
        await this.props.dispatchCreateQuoteFromPolicy();
        await this.props.dispatchHideLoadingScreen();
    }

    async showFieldUpdate(e: any) {
        let value = e.target.id;
        this.props.dispatchShowUpdateCustomerInfo(value);
    }

    async getBankDetails() {
        if (this.props.profile.countryId === SA_COUNTRY_ID_NUMBER) {
            await postToController(this.props.dispatch, 'GetAllBankNames', JSON.stringify({})).then(async (response) => {
                await this.setState({ bankList: response });
                return true;
            })
        }
        else {
            await this.setState({ bankList: NAM_BANKS_AND_BRANCHES });
            return true;
        }
    }

    async getAccountTypes() {
        await postToController(this.props.dispatch, 'GetBankAccountTypes', JSON.stringify({})).then(async (response) => {
            await this.setState({ accountTypeList: response });
            return true;
        })
    }

    async getDebitDays() {
        await postToController(this.props.dispatch, 'GetDebitOrderDays', JSON.stringify({})).then(async (response) => {
            await this.setState({ debitDayList: response });
            return true;
        })
    }

    async getLists() {
        if (this.state.bankList === undefined) {
            await this.getBankDetails().then(async (resp) => {
                if (resp !== null) {
                    await this.getAccountTypes().then(async (res) => {
                        if (res !== null) {
                            await this.getDebitDays().then(async (res) => {
                                if (res !== null) {
                                    await this.setState({ bankingDetailsEmpty: false });
                                }
                            })
                        }
                    })
                }
            })
        }
    }

    async cancelNewPayment() {
        await this.setState({ addPayment: false });
    }

    cancelEdit(e: any) {
        this.setState({
            isInEdit: false,
        });
    }

    async saveEdit(e: any) {
        await this.props.dispatch(updateBankingDetails(this.state));
        await this.props.dispatch(getUserBankingDetails());
        this.setState({ isInEdit: false });
    }

    async editInfo() {
        let currBank = this.props.profile.bankingDetails.bank;
        let currBranch = this.props.profile.bankingDetails.branch;
        let currAccount = this.props.profile.bankingDetails.bankAccountType;
        let bank = this.state.bankList.filter(function (item) {
            return item.description === currBank
        })
        this.setState({ selectedBank: bank[0] });
        await this.setState({ branchList: bank[0].bankBranches });

        let branch = this.state.branchList.filter(function (item) {
            return item.branchName === currBranch
        })

        this.setState({ selectedBranch: branch[0] });

        let accountType = this.state.accountTypeList.filter(function (item) {
            return item.description === currAccount
        })
        this.setState({ selectedAccountType: accountType[0], editHolder: this.props.profile.bankingDetails.accountholder, branchDetailsEmpty: false });

        this.setState({ isInEdit: true });
    }

    async addNewPayment(e: any) {
        await this.setState({ addPayment: true });
    }

    async handleBankSelection(e: any) {
        let bank = this.state.bankList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedBank: bank[0] });
        await this.setState({ branchList: bank[0].bankBranches });
        await this.setState({ branchDetailsEmpty: false });
    }

    async handleBankDropdownToggle(e: any) {
        await this.setState({
            bankDropdownOpen: !this.state.bankDropdownOpen
        });
    }

    async handleBranchSelection(e: any) {
        let branch = this.state.branchList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedBranch: branch[0] });
    }

    async handleBranchDropdownToggle(e: any) {
        await this.setState({
            branchDropdownOpen: !this.state.branchDropdownOpen
        });
    }

    async handleAccountTypeSelection(e: any) {
        let accountType = this.state.accountTypeList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedAccountType: accountType[0] });
        await this.setState({ branchDetailsEmpty: false });
    }

    async handleAccountTypeDropdownToggle(e: any) {
        await this.setState({
            accountTypeDropdownOpen: !this.state.accountTypeDropdownOpen
        });
    }

    public render() {
        const { profile } = this.props;
        let bankDropdown = [];
        let branchDropdown = [];
        let accountTypeDropdown = [];
        if (!this.state.bankingDetailsEmpty) {
            bankDropdown = this.state.bankList.map((item) => {
                return <Dropdown.Item eventKey={item.id} key={item.id} value={item.description}>{item.description}</Dropdown.Item>
            });
            accountTypeDropdown = this.state.accountTypeList.map((item) => {
                return <Dropdown.Item eventKey={item.id} key={item.id} value={item.description}>{item.description}</Dropdown.Item>
            });
        }
        if (!this.state.branchDetailsEmpty) {
            branchDropdown = this.state.branchList.map((item) => {
                return <Dropdown.Item eventKey={item.id} key={item.id} value={item.branchName}>{item.branchName}</Dropdown.Item>
            });
        }
        return (
            <div id="PaymentDeetsCard">
                <div className="PaymentDeetsDebitCard">
                    {(profile.bankingDetails !== undefined && profile.bankingDetails.id && !this.state.addPayment && this.state.currAccountType != "Credit") &&
                        <>
                            {!this.state.isInEdit &&
                                <div className="container">
                                    <p className="Credit-card pt-4">Debit order</p>
                                    <div className="row">
                                        <div className="col-lg-6 col-6">
                                            <p>Account holder</p>
                                        </div>
                                        <div className="col-lg-6 col-6">
                                            <p className="font-weight-bold text-right">{profile.bankingDetails.accountHolder}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6 col-4">
                                            <p>Bank</p>
                                        </div>
                                        <div className="col-lg-6 col-8">
                                            <p className="font-weight-bold text-right">{profile.bankingDetails.bank}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6 col-6">
                                            <p>Account type</p>
                                        </div>
                                        <div className="col-lg-6 col-6">
                                            <p className="font-weight-bold text-right">{profile.bankingDetails.bankAccountType}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6 col-6">
                                            <p>Account number</p>
                                        </div>
                                        <div className="col-lg-6 col-6">
                                            <p className="font-weight-bold text-right">{profile.bankingDetails.accountNumber}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6 col-6">
                                            <p>Branch code</p>
                                        </div>
                                        <div className="col-lg-6 col-6">
                                            <p className="font-weight-bold text-right">{profile.bankingDetails.branch}</p>
                                        </div>
                                    </div>
                                    {profile.bankingDetails.sourceOfIncomeDescription &&
                                        <div className="row">
                                            <div className="col-lg-6 col-6">
                                                <p>Source of income</p>
                                            </div>
                                            <div className="col-lg-6 col-6">
                                                <p className="font-weight-bold text-right">{profile.bankingDetails.sourceOfIncomeDescription}</p>
                                            </div>
                                        </div>
                                    }
                                    <hr />
                                    <div className="col-12 mt-3 pb-3 p-0 text-center">
                                        <button className="btn btn-outline-red mr-lg-3 mr-sm-3 d-none" id='UpdateBankingInfo' onClick={this.editInfo}>Update banking info</button>
                                        <button className="btn btn-solid-red mt-lg-0 mt-sm-0 mt-2 d-none" id='MakePayment'>Make payment</button>
                                    </div>
                                </div>
                            }
                            {(this.state.isInEdit && !this.state.addPayment) &&
                                <>
                                    <div className="container">
                                        <p className="Credit-card pt-4">Debit order</p>
                                        <div className="row">
                                            <div className="col-lg-6 col-6">
                                                <p>Account holder</p>
                                            </div>
                                            <div className="col-lg-6 col-6">
                                                <input type='text' className="col-lg-6 col-12 mb-2 form-control text-right" value={this.state.editHolder} name="editHolder" onChange={this.handleChange}></input>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-4">
                                                <p>Bank</p>
                                            </div>
                                            <div className="col-lg-6 col-6">
                                                <Dropdown
                                                    id="bank-select-dropdown"
                                                    onSelect={this.handleBankSelection}
                                                    onToggle={this.handleBankDropdownToggle}
                                                    className="col-lg-6 col-12 mb-2 fit-full">
                                                    <Dropdown.Toggle id="dropdown-basic" >
                                                        <div className="row dropdown-height">
                                                            <div className="dropdown-basic-title-text col-10">
                                                                {this.state.selectedBank.description}
                                                            </div>
                                                            <div className="col-2">
                                                                <Image src='Images/red-arrow-up-24-px.svg' className={this.state.bankDropdownOpen ? 'visible' : 'invisible'} />
                                                                <Image src='Images/red-arrow-down-24-px.svg' className={this.state.bankDropdownOpen ? 'invisible' : 'visible'} />
                                                            </div>
                                                        </div>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu id='bankDropDown'>
                                                        {bankDropdown}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-6">
                                                <p>Account type</p>
                                            </div>
                                            <div className="col-lg-6 col-6">
                                                <Dropdown
                                                    id="account-type-select-dropdown"
                                                    onSelect={this.handleAccountTypeSelection}
                                                    onToggle={this.handleAccountTypeDropdownToggle}
                                                    className="col-lg-6 col-12 mb-2 fit-full">
                                                    <Dropdown.Toggle id="dropdown-basic" >
                                                        <div className="row dropdown-height">
                                                            <div className="dropdown-basic-title-text col-10">
                                                                {this.state.selectedAccountType.description}
                                                            </div>
                                                            <div className="col-2">
                                                                <Image src='Images/red-arrow-up-24-px.svg' className={this.state.accountTypeDropdownOpen ? 'visible' : 'invisible'} />
                                                                <Image src='Images/red-arrow-down-24-px.svg' className={this.state.accountTypeDropdownOpen ? 'invisible' : 'visible'} />
                                                            </div>
                                                        </div>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu id='accountTypeDropDown'>
                                                        {accountTypeDropdown}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-6">
                                                <p>Account number</p>
                                            </div>
                                            <div className="col-lg-6 col-6">
                                                <input type='text' className="col-lg-6 col-12 mb-2 form-control text-right" value={this.state.editAccountNumber} name="editAccountNumber" onChange={this.handleChange}></input>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-6">
                                                <p>Branch code</p>
                                            </div>
                                            <div className="col-lg-6 col-6">
                                                <Dropdown
                                                    id="branch-select-dropdown"
                                                    onSelect={this.handleBranchSelection}
                                                    onToggle={this.handleBranchDropdownToggle}
                                                    className="col-lg-6 col-12 mb-2 fit-full">
                                                    <Dropdown.Toggle id="dropdown-basic" >
                                                        <div className="row dropdown-height">
                                                            <div className="dropdown-basic-title-text col-10">
                                                                {this.state.selectedBranch !== undefined && this.state.selectedBranch.branchName}
                                                            </div>
                                                            <div className="col-2">
                                                                <Image src='Images/red-arrow-up-24-px.svg' className={this.state.branchDropdownOpen ? 'visible' : 'invisible'} />
                                                                <Image src='Images/red-arrow-down-24-px.svg' className={this.state.branchDropdownOpen ? 'invisible' : 'visible'} />
                                                            </div>
                                                        </div>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu id='bankDropDown'>
                                                        {branchDropdown}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="col-12 mt-3 pb-3 p-0 text-center">
                                            <button className="btn btn-outline-red mr-lg-3 mr-sm-3 d-none" id='SaveUpdateBankingInfo' onClick={this.saveEdit}>Save changes</button>
                                            <button className="btn btn-outline-red mr-lg-3 mr-sm-3 d-none" id='CancelUpdateBankingInfo' onClick={this.cancelEdit}>Cancel changes</button>
                                        </div>
                                    </div>

                                </>
                            }
                        </>
                    }
                    {!this.state.addPayment &&
                        <>
                        </>

                        //<div className="col-12 mt-3 pb-3 p-0">
                        //    <button className="btn btn-outline-green mr-lg-3" id='AddNewPayment' onClick={this.addNewPayment}><img src="./images/PersonalDetails/icons-navigation-plus-24-px.png" />&nbsp; Add new payment</button>
                        //</div>
                    }

                    {this.state.addPayment &&
                        <>
                        </>
                        //<PaymentDeetsAdd />
                    }
                </div>

                <div className="PaymentDeetsCreditCard">
                    {(profile.bankingDetails !== undefined && profile.bankingDetails.id && !this.state.addPayment && this.state.currAccountType == "Credit") &&
                        <>
                            {!this.state.isInEdit &&
                                <div className="container">
                                    <p className="Credit-card pt-4">Credit card</p>
                                    <div className="row">
                                        <div className="col-lg-6 col-6">
                                            <p>Card number</p>
                                        </div>
                                        <div className="col-lg-6 col-6">
                                            <p className="font-weight-bold text-right">{this.props.profile.bankingDetails.creditCard.accountNumber}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6 col-4">
                                            <p>Expiration date</p>
                                        </div>
                                        <div className="col-lg-6 col-8">
                                            <p className="font-weight-bold text-right">{this.props.profile.bankingDetails.creditCard.expiryDate.substr(5, 2) + "/" + this.props.profile.bankingDetails.creditCard.expiryDate.substr(0, 4)}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6 col-6">
                                            <p>Account holder</p>
                                        </div>
                                        <div className="col-lg-6 col-6">
                                            <p className="font-weight-bold text-right">{this.props.profile.name + " " + this.props.profile.surname}</p>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="w-100 text-right pb-4 m-0 d-none d-lg-block d-xl-block">
                                        <button className="btn btn-outline-red" onClick={this.handleUpdateBankDetails}>Change credit card info</button>
                                    </div>
                                    <div className="w-100 text-center pb-4 m-0 d-lg-none d-xl-none d-sm-block d-md-block">
                                        <button className="btn btn-outline-red w-100" onClick={this.handleUpdateBankDetails}>Change credit card info</button>
                                    </div>
                                </div>

                            }
                            {(this.state.isInEdit && !this.state.addPayment) &&
                                <>
                                    <div className="container">
                                        <p className="Credit-card pt-4">Debit order</p>
                                        <div className="row">
                                            <div className="col-lg-6 col-6">
                                                <p>Account holder</p>
                                            </div>
                                            <div className="col-lg-6 col-6">
                                                <input type='text' className="col-lg-6 col-12 mb-2 form-control text-right" value={this.state.editHolder} name="editHolder" onChange={this.handleChange}></input>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-4">
                                                <p>Bank</p>
                                            </div>
                                            <div className="col-lg-6 col-6">
                                                <Dropdown
                                                    id="bank-select-dropdown"
                                                    onSelect={this.handleBankSelection}
                                                    onToggle={this.handleBankDropdownToggle}
                                                    className="col-lg-6 col-12 mb-2 fit-full">
                                                    <Dropdown.Toggle id="dropdown-basic" >
                                                        <div className="row dropdown-height">
                                                            <div className="dropdown-basic-title-text col-10">
                                                                {this.state.selectedBank.description}
                                                            </div>
                                                            <div className="col-2">
                                                                <Image src='Images/red-arrow-up-24-px.svg' className={this.state.bankDropdownOpen ? 'visible' : 'invisible'} />
                                                                <Image src='Images/red-arrow-down-24-px.svg' className={this.state.bankDropdownOpen ? 'invisible' : 'visible'} />
                                                            </div>
                                                        </div>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu id='bankDropDown'>
                                                        {bankDropdown}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-6">
                                                <p>Account type</p>
                                            </div>
                                            <div className="col-lg-6 col-6">
                                                <Dropdown
                                                    id="account-type-select-dropdown"
                                                    onSelect={this.handleAccountTypeSelection}
                                                    onToggle={this.handleAccountTypeDropdownToggle}
                                                    className="col-lg-6 col-12 mb-2 fit-full">
                                                    <Dropdown.Toggle id="dropdown-basic" >
                                                        <div className="row dropdown-height">
                                                            <div className="dropdown-basic-title-text col-10">
                                                                {this.state.selectedAccountType.description}
                                                            </div>
                                                            <div className="col-2">
                                                                <Image src='Images/red-arrow-up-24-px.svg' className={this.state.accountTypeDropdownOpen ? 'visible' : 'invisible'} />
                                                                <Image src='Images/red-arrow-down-24-px.svg' className={this.state.accountTypeDropdownOpen ? 'invisible' : 'visible'} />
                                                            </div>
                                                        </div>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu id='accountTypeDropDown'>
                                                        {accountTypeDropdown}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-6">
                                                <p>Account number</p>
                                            </div>
                                            <div className="col-lg-6 col-6">
                                                <input type='text' className="col-lg-6 col-12 mb-2 form-control text-right" value={this.state.editAccountNumber} name="editAccountNumber" onChange={this.handleChange}></input>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-6">
                                                <p>Branch code</p>
                                            </div>
                                            <div className="col-lg-6 col-6">
                                                <Dropdown
                                                    id="branch-select-dropdown"
                                                    onSelect={this.handleBranchSelection}
                                                    onToggle={this.handleBranchDropdownToggle}
                                                    className="col-lg-6 col-12 mb-2 fit-full">
                                                    <Dropdown.Toggle id="dropdown-basic" >
                                                        <div className="row dropdown-height">
                                                            <div className="dropdown-basic-title-text col-10">
                                                                {this.state.selectedBranch !== undefined && this.state.selectedBranch.branchName}
                                                            </div>
                                                            <div className="col-2">
                                                                <Image src='Images/red-arrow-up-24-px.svg' className={this.state.branchDropdownOpen ? 'visible' : 'invisible'} />
                                                                <Image src='Images/red-arrow-down-24-px.svg' className={this.state.branchDropdownOpen ? 'invisible' : 'visible'} />
                                                            </div>
                                                        </div>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu id='bankDropDown'>
                                                        {branchDropdown}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="col-12 mt-3 pb-3 p-0 text-center">
                                            <button className="btn btn-outline-red mr-lg-3 mr-sm-3 d-none" id='SaveUpdateBankingInfo' onClick={this.saveEdit}>Save changes</button>
                                            <button className="btn btn-outline-red mr-lg-3 mr-sm-3 d-none" id='CancelUpdateBankingInfo' onClick={this.cancelEdit}>Cancel changes</button>
                                        </div>
                                    </div>

                                </>
                            }
                        </>
                    }
                    {!this.state.addPayment &&
                        <>
                        </>

                        //<div className="col-12 mt-3 pb-3 p-0">
                        //    <button className="btn btn-outline-green mr-lg-3" id='AddNewPayment' onClick={this.addNewPayment}><img src="Images/PersonalDetails/icons-navigation-plus-24-px.png" />&nbsp; Add new payment</button>
                        //</div>
                    }

                    {this.state.addPayment &&
                        <>
                        </>
                        //<PaymentDeetsAdd />
                    }
                </div>

            </div>

        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchShowLoadingScreen: () => dispatch(showLoadingScreen()),
        dispatchHideLoadingScreen: () => dispatch(hideLoadingScreen()),
        dispatchCreateQuoteFromPolicy: () => dispatch(createQuoteFromPolicyCardUpdate()),
        dispatchIveriSubmission: (quote) => dispatch(IveriSubmission(quote)),
        dispatchShowChangeCreditCard: () => dispatch(showChangeCreditCard()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDeets);